var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
import { asSliceSelectors } from '../types';
var SLICE_NAME = 'gdprData';
var initialState = {
    grantedCategories: null,
};
var rawSlice = createSlice({
    name: SLICE_NAME,
    initialState: initialState,
    reducers: {
        setGrantedCategories: function (state, action) {
            state.grantedCategories = action.payload;
        },
    },
});
var selectors = asSliceSelectors({
    getGrantedCategories: function (state) {
        return state[SLICE_NAME].grantedCategories;
    },
    isPerformanceCategoryGranted: function (state) {
        var grantedCategories = selectors.getGrantedCategories(state);
        return grantedCategories === null ? false : grantedCategories.performance;
    },
    isMarketingCategoryGranted: function (state) {
        var grantedCategories = selectors.getGrantedCategories(state);
        return grantedCategories === null ? false : grantedCategories.marketing;
    },
});
export var gdprDataSlice = {
    name: SLICE_NAME,
    actions: __assign({}, rawSlice.actions),
    selectors: selectors,
};
export default rawSlice.reducer;
